<template>
  <article-detail-component v-if="article">

    <div slot="title" v-if="!$store.state.isEnhanced">
      <div class="title">{{ article.title }}</div>

      <issue-authors v-bind:authors="article.authors"></issue-authors>
    </div>

    <sidebar-article-section slot="bar" :article="article"></sidebar-article-section>

    <div slot="keywords" class="keywords">
      <div class="title">
        Keywords:
      </div>
      <div class="">
        <div class="link" v-for="keyword in article.keywords">{{keyword}}</div>
      </div>
    </div>

    <div slot="current_article" class="current-issue">
      <em>Current Article:</em>
      <condensed-issue class="mt-2" v-bind:issue="article"></condensed-issue>
    </div>

    <div>
      <condensed-issue v-for="(issue, index) in issues" v-if="index<5" :key="issue.id" v-bind:issue="issue"></condensed-issue>
    </div>

  </article-detail-component>
</template>

<script>
  import IssueAuthors from '@/components/shared/IssueAuthorsComponent'
  import ArticleDetailComponent from '@/components/publications/article-detail/ArticleDetailComponent'
  import CondensedIssue from '@/components/shared/CondensedIssueComponent'
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'
  import SidebarArticleSection from '@/components/main-layout/sidebar/SidebarArticleSectionComponent'

  export default {
    name: 'article-detail-related',
    components: {
      IssueAuthors,
      ArticleDetailComponent,
      CondensedIssue,
      SidebarArticleSection
    },
    mixins: [UtilityMixin],
    data () {
      return {
        issues: [],
        article: false,
        currentIssueCutted: false
      }
    },
    created () {
      this.$parent.$parent.prevPage = false
      this.$parent.$parent.nextPage = {name: 'article-metrics'}
      this.$parent.$parent.prevSlide = {name: 'article-detail-authors'}
      this.$parent.$parent.nextSlide = false

      this.$http.get(this.$store.state.dataUrlArticleList).then(function (response) {
        this.issues = response.body.articles
      }, function () {
      })

      if (this.$parent.article) {
        this.article = Object.assign({}, this.$parent.article)
      }
    }
  }
</script>


<style lang="scss" scoped>
  .title {
    color: $primary-color;
    font-size: 32px;
  }
  .keywords {
    margin-top: 10px;
    .title {
    font-family: 'Merriweather';
    font-style: italic;
    color: $primary-color;
    font-size: 14px;
    margin-bottom: 15px;
    }
    .link {
    height: 48px;
    line-height: 48px;
    text-align: center;
    font-family: 'Merriweather';
    font-style: italic;
    font-size: 16px;
    color: $primary-color;
    background-color: #F2E8E8;
    margin-bottom: 12px;
    display: inline-block;
    width: 135px;
    margin-right: 5px;
    }
  }
  .current-issue {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid $grey-border;
  }
  .article-quick-links {
    margin-bottom: 40px;
  }
</style>



// WEBPACK FOOTER //
// RelatedArticlesPage.vue?4871af26